import * as React from 'react';
import MuiTableSortLabel from '@mui/material/TableSortLabel';
import EDOverlay from '../../Overlay/EDOverlay';
import EDAvatar from '../../Avatar/EDAvatar';
import { Theme } from '@mui/material';

import { withStyles } from 'tss-react/mui';

interface IProps {
  active?: boolean;
  direction?: 'asc' | 'desc';
  onClick?: () => void;
  hideSortIcon?: boolean;
  sortIndex?: number;
  classes?: any;
}

const styles = (theme: Theme) => ({
  avatar: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
    fontSize: theme.typography.pxToRem(10),
    background: theme.palette.primary.main,
    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
  overlay: {
    right: theme.spacing(-0.5),
    bottom: `calc(50% - ${theme.spacing(2)})`,
  },
  overlayRoot: {
    width: 'fit-content',
  },
  sortLabelRoot: {},
});

const EDTableSortLabel: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes, sortIndex, hideSortIcon, ...rest } = props;
  return (
    <EDOverlay
      overlay={
        props.sortIndex && (
          <EDAvatar classes={{ colorDefault: classes.avatar }}>
            {props.sortIndex < 10 ? props.sortIndex : '*'}
          </EDAvatar>
        )
      }
      classes={{ overlay: classes.overlay, root: classes.overlayRoot }}
      className={classes.overlayRoot}
    >
      <MuiTableSortLabel
        hideSortIcon={hideSortIcon === undefined ? true : hideSortIcon}
        classes={{ root: classes.sortLabelRoot }}
        {...rest}
      />
    </EDOverlay>
  );
};

export default withStyles(EDTableSortLabel, styles);
